import { supabase } from './supabase';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
const API_TIMEOUT_MS = Number(process.env.REACT_APP_API_TIMEOUT_MS || 15000);

async function authHeader() {
  const { data } = await Promise.race([
    supabase.auth.getSession(),
    new Promise((_, reject) => setTimeout(() => reject(new Error('Session lookup timed out')), 5000)),
  ]);
  const token = data?.session?.access_token;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function api(path, options = {}) {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), options.timeoutMs || API_TIMEOUT_MS);
  let res;
  try {
    const isFormData = options.body instanceof FormData;
    const headers = {
      ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
      ...(await authHeader()),
      ...(options.headers || {}),
    };
    res = await fetch(`${BASE}${path}`, { ...options, headers, signal: controller.signal });
  } catch (err) {
    if (err?.name === 'AbortError') {
      throw new Error(`RozOps backend request timed out at ${BASE}. Please check backend and refresh the page.`);
    }
    if (err?.message === 'Session lookup timed out') {
      throw new Error('RozOps session lookup timed out. Please refresh the page and try again.');
    }
    throw new Error(`Cannot reach RozOps backend at ${BASE}. Please make sure the backend is running and refresh the page.`);
  } finally {
    clearTimeout(timeout);
  }
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    const msg = body?.detail || body?.message || `HTTP ${res.status}`;
    throw new Error(typeof msg === 'string' ? msg : JSON.stringify(msg));
  }
  return body;
}

export const apiGet = (path) => api(path);
export const apiPost = (path, data) => api(path, { method: 'POST', body: JSON.stringify(data) });
export const apiPostForm = (path, form, options = {}) => api(path, { method: 'POST', body: form, ...options });
export const apiPatch = (path, data) => api(path, { method: 'PATCH', body: JSON.stringify(data) });
export const apiDelete = (path) => api(path, { method: 'DELETE' });
